import { InfoCircleOutlined } from '@ant-design/icons';
import { AlertProps } from 'antd';
import React from 'react';
import { StyledAlert, StyledAlertIconWrapper } from './index.styled';
import { defaultTheme } from '@nxsys/constants/defaultConfig';
import { Icons } from '@nxsys/types/icons';

interface AppAlertProps extends AlertProps {
  variant?: 'info' | 'success' | 'warning' | 'error';
  customStyle?: React.CSSProperties;
  // When true, the info icon is rendered plainly (no circular wrapper badge),
  // matching the other alert types.
  hideIconWrapper?: boolean;
}

const AppAlert: React.FC<AppAlertProps> = ({
  variant = 'info',
  type,
  icon,
  showIcon = true,
  customStyle,
  style,
  hideIconWrapper = false,
  ...props
}) => {
  const getDefaultIcon = (alertType: string) => {
    if (icon !== undefined) return icon;

    switch (alertType) {
      case 'info':
        return hideIconWrapper ? (
          <InfoCircleOutlined className="mt-[2px]" />
        ) : (
          <StyledAlertIconWrapper variant={variant}>
            <InfoCircleOutlined />
          </StyledAlertIconWrapper>
        );
      case 'warning':
        return <InfoCircleOutlined className="mt-[2px]" />;
      case 'success':
        return (
          <div className="mr-1">
            <Icons.IconCheckCircle
              color={defaultTheme.theme.palette.success.main}
            />
          </div>
        );
      case 'error':
        return (
          <div className="mr-1">
            <Icons.IconCloseCircle
              color={defaultTheme.theme.palette.error[500]}
            />
          </div>
        );
      default:
        return undefined;
    }
  };

  const alertType = type || variant;
  const finalStyles = {
    ...(alertType === 'success' && {
      backgroundColor: defaultTheme.theme.palette.white,
      borderColor: defaultTheme.theme.palette.success.main,
    }),
    ...(alertType === 'error' && {
      backgroundColor: defaultTheme.theme.palette.white,
      borderColor: defaultTheme.theme.palette.error[500],
    }),
    ...customStyle,
    ...style,
  };

  return (
    <StyledAlert
      variant={variant}
      type={alertType as AlertProps['type']}
      icon={getDefaultIcon(alertType)}
      showIcon={showIcon}
      style={finalStyles}
      {...props}
    />
  );
};

export default AppAlert;
